import { __awaiter } from "tslib";
import * as React from 'react';
import { render } from 'react-dom';
import feedLoader from 'shared/feed/feedLoader';
import { siteInfoLoader } from 'shared/siteInfo/siteInfoLoader';
import { trackingLoader } from 'shared/tracking/trackingLoader';
import AdContainer from './components/AdContainer';
import setPublicPath from './setPublicPath';
// Ensure dynamic imports are referenced
// absolutely when in hosted, production mode.
setPublicPath();
const appInit = () => __awaiter(void 0, void 0, void 0, function* () {
    // Retrieve additional site info if available.
    yield siteInfoLoader();
    // transform ad data for feed content
    // preload tracking before rendering app
    yield Promise.all([feedLoader(), trackingLoader()]);
    render(React.createElement(AdContainer, null), document.querySelector('#root'));
});
appInit();
